<template>
    <div v-if="users && users.length > 0" class="imu-wrapper">
        <div class="imu-section-title">Customer Sales Representative</div>

        <div class="d-flex align-items-center">
            <!-- First user always visible -->
            <div class="imu-card">
                <div class="imu-avatar-wrap">
                    <div class="imu-avatar">
                        <img
                            v-if="users[0].profile_photo"
                            :src="users[0].profile_photo"
                            alt="Profile"
                            class="imu-avatar-img"
                        />
                        <img
                            v-else
                            src="/maincss/images/account-grey-icon.svg"
                            alt="No Photo"
                            class="imu-avatar-placeholder"
                        />
                    </div>
                </div>
                <div>
                    <div class="imu-name">{{ fullName(users[0]) }}</div>
                    <div v-if="users[0].email" class="imu-email">{{ users[0].email }}</div>
                    <div class="imu-mobile">{{ users[0].mobile || "" }}</div>
                   
                </div>
            </div>

            <!-- +N badge if more than 1 -->
            <div
                v-if="users.length > 1"
                class="imu-more-badge"
                @click="showModal = true"
            >
                +{{ users.length - 1 }}
            </div>
        </div>

        <!-- Modal -->
        <div v-if="showModal" class="imu-overlay" @click.self="showModal = false">
            <div class="imu-modal">
                <div class="imu-modal-header">
                    <span class="imu-modal-title">Customer Sales Representatives</span>
                    <button class="imu-modal-close" @click="showModal = false">&times;</button>
                </div>
                <div class="imu-modal-body">
                    <div
                        v-for="u in users"
                        :key="u.id"
                        class="imu-card imu-card--full"
                    >
                        <div class="imu-avatar-wrap">
                            <div class="imu-avatar">
                                <img
                                    v-if="u.profile_photo"
                                    :src="u.profile_photo"
                                    alt="Profile"
                                    class="imu-avatar-img"
                                />
                                <img
                                    v-else
                                    src="/maincss/images/account-grey-icon.svg"
                                    alt="No Photo"
                                    class="imu-avatar-placeholder"
                                />
                            </div>
                        </div>
                        <div>
                            <div class="imu-name">{{ fullName(u) }}</div>
                            <div v-if="u.email" class="imu-email">{{ u.email }}</div>
                            <div class="imu-mobile">{{ u.mobile || "" }}</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IndustryMatchedUsersGroup",
    props: {
        users: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showModal: false
        };
    },
    methods: {
        fullName(user) {
            if (!user) return "";
            return `${user.first_name || ""} ${user.last_name || ""}`.trim();
        }
    }
};
</script>

<style scoped>
.imu-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.imu-section-title {
    font-size: 15px;
    font-weight: bold;
    color: #000000;
    letter-spacing: 0.6px;
}

.imu-card {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #e8ebf0;
    border-radius: 10px;
    padding: 10px 16px;
}

.imu-card--full {
    width: 100%;
}

.imu-avatar-wrap {
    position: relative;
    margin-right: 12px;
    flex-shrink: 0;
}

.imu-avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 2px solid #d7d9e0;
    overflow: hidden;
    background: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
}

.imu-avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.imu-avatar-placeholder {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.imu-name {
    font-size: 14px;
    font-weight: 600;
    color: #222;
    line-height: 1.3;
}

.imu-mobile {
    font-size: 12px;
    color: #7a8499;
    margin-top: 2px;
}

.imu-email {
    font-size: 12px;
    color: #7a8499;
    margin-top: 1px;
}

.imu-more-badge {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #1a73e8;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    cursor: pointer;
    flex-shrink: 0;
    box-shadow: 0 2px 6px rgba(26, 115, 232, 0.35);
    transition: background 0.15s;
}

.imu-more-badge:hover {
    background: #1558b0;
}

.imu-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.imu-modal {
    background: #fff;
    border-radius: 14px;
    width: 780px;
    max-width: 92vw;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    overflow: hidden;
}

.imu-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 12px;
    border-bottom: 1px solid #edf0f5;
}

.imu-modal-title {
    font-size: 15px;
    font-weight: 700;
    color: #222;
}

.imu-modal-close {
    background: none;
    border: none;
    font-size: 22px;
    color: #7a8499;
    cursor: pointer;
    line-height: 1;
    padding: 0 4px;
}

.imu-modal-close:hover {
    color: #222;
}

.imu-modal-body {
    padding: 16px 20px;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

@media (max-width: 540px) {
    .imu-modal-body {
        grid-template-columns: 1fr;
    }
}
</style>
